import { atomFamily, loadable } from "jotai/utils";
import { atom } from "jotai";

type FetchResponse = {
  results: unknown[];
  count: number;
};

// Base atom that suspends
const accountAdminCountAtomFamily_SUSPENDS = atomFamily(
  (currentAccountId: number | undefined) => {
    const debugLabel = `accountAdminCountAtomFamily_SUSPENDS({ currentAccountId: ${currentAccountId} })`;

    const adminsCountAtom = atom<Promise<number>>(async () => {
      if (!currentAccountId) {
        return 0;
      }

      const params = new URLSearchParams({
        role: "admin",
        limit: "1", // We only need the count, not the actual data
      });

      const res = await fetch(
        `/api/v4/accounts/${currentAccountId}/members?${params}`,
      );

      if (!res.ok) {
        // Return 0 on error instead of throwing to avoid error boundary
        return 0;
      }

      const response: FetchResponse = await res.json();

      // Return count from response, or length of results array as fallback
      return response.count ?? response.results?.length ?? 0;
    });

    adminsCountAtom.debugLabel = debugLabel;
    return adminsCountAtom;
  },
);

// Does NOT suspend due to loadable usage
export const accountAdminCountAtomFamily = atomFamily(
  (currentAccountId: number | undefined) => {
    const baseAtom = accountAdminCountAtomFamily_SUSPENDS(currentAccountId);
    return loadable(baseAtom);
  },
);
